import { Button } from '@kalos/ui';
import { Clock } from 'lucide-react';

interface CallbackPromptProps {
  /** Human-readable recency summary, e.g. "10 days ago (May 26)" */
  label: string;
  onYes: () => void;
  onNo: () => void;
}

/**
 * Banner shown when the property had a visit completed within the last 30 days,
 * prompting the CSR to flag the new job as a callback. Rendered in both the
 * Review step (Step 2) and the Schedule step (Step 3).
 */
export const CallbackPrompt = ({ label, onYes, onNo }: CallbackPromptProps) => (
  <div className="flex flex-wrap items-center justify-between gap-3 rounded-md border border-blue-200 bg-blue-50 px-4 py-2.5">
    <div className="flex items-start gap-2 text-xs leading-relaxed text-blue-800">
      <Clock className="mt-0.5 h-4 w-4 shrink-0 text-blue-500" />
      <span>
        Last visit was <span className="font-semibold">{label}</span> — within the 30-day window.
        Mark this as a callback?
      </span>
    </div>
    <div className="flex shrink-0 items-center gap-2">
      <Button
        type="button"
        size="sm"
        variant="outline"
        onClick={onYes}
        className="text-xs font-semibold text-blue-600"
      >
        Yes
      </Button>
      <Button
        type="button"
        size="sm"
        variant="outline"
        onClick={onNo}
        className="text-xs font-semibold text-blue-600"
      >
        No
      </Button>
    </div>
  </div>
);
